




































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

import '../globals';
import { Route } from '@/models/route';
import { Profile } from '@/constants';
import { ChipModel, RouteFilterSet } from '@/models/filter';
import FilterHelper from '@/services/filter-helper';

@Component
export default class RouteFilterPage extends Vue {

    @Prop(Object) public filterSet!: RouteFilterSet;
    @Prop(Object) public eventTarget!: Vue;

    private clearButtonActive: boolean = false;
    private applyButtonActive: boolean = false;
    private applyButtonText: string = '';
    private tmpRoutes: Route[] = [];
    private tmpFilterSet: RouteFilterSet;

    private profileChips: ChipModel[] = [];

    public async mounted() {
        await this.$store.waitUntilReady();

        // copy filters
        this.tmpFilterSet = FilterHelper.duplicateRouteFilterSet(this.filterSet);
        this.tmpRoutes = [];

        // init chip models based on filter
        this.initChips();
        this.initChipsByFilterSet();

        // update filtered pois
        this.recalculateFilteredRoutes();
    }

    private initChips() {
        this.profileChips = [
            new ChipModel(Profile.EINGESCHRAENKTE_MOBILITAET, this.$t('route_profile.1')),
            new ChipModel(Profile.FAMILIEN, this.$t('route_profile.2')),
            new ChipModel(Profile.SENIOREN, this.$t('route_profile.3')),
            new ChipModel(Profile.SPORTLICH, this.$t('route_profile.4')),
            new ChipModel(Profile.SCHULEN, this.$t('route_profile.5')),
        ];
    }

    private initChipsByFilterSet() {
        this.profileChips.forEach(profileChip => {
            profileChip.checked = !(this.tmpFilterSet.profileFilters.indexOf(profileChip.id) === -1);
        });
    }

    private recalculateFilteredRoutes() {
        // update cached filtered pois
        this.tmpRoutes = FilterHelper.getFilteredRoutes(this.$store.routes, this.tmpFilterSet);

        // check if there is any filter
        this.applyButtonActive = this.tmpRoutes.length > 0;

        this.applyButtonText = this.$tc('route.filter_apply', this.tmpRoutes.length, { count: this.tmpRoutes.length });

        this.clearButtonActive = FilterHelper.isRouteFilterSetModified(this.tmpFilterSet);
    }

    private clearAllFilters() {
        // create new empty filterset
        this.tmpFilterSet = FilterHelper.createRouteFilterSet();

        // update chip states
        this.initChipsByFilterSet();

        // update filtered pois
        this.recalculateFilteredRoutes();

        this.eventTarget.$emit('routeFilterApplied', this.tmpFilterSet, this.tmpRoutes);

        this.$ga.event({
            eventCategory: 'route',
            eventAction: 'filterCleared',
        });
    }

    private numberChipClicked(chip: ChipModel, chipGroup: ChipModel[], filters: number[]) {
        chip.checked = !chip.checked;

        // clean and refill array, fancy js
        filters.splice(0, filters.length);
        filters.unshift(...chipGroup.filter(c => c.checked).map(c => c.id));

        // update results
        this.recalculateFilteredRoutes();
    }

    private applyFilters() {
        this.eventTarget.$emit('routeFilterApplied', this.tmpFilterSet, this.tmpRoutes);
        this.$f7router.back();

        this.$ga.event({
            eventCategory: 'route',
            eventAction: 'filterApplied',
        });
    }
}
